import PlayerRegistrationStep from './step';

export default class PlayerRegistrationStep4 extends PlayerRegistrationStep {
    static getRequiredRefs() {
        return [];
    }

    initConcrete() {
        this.addListenersConcrete();
    }

    addListenersConcrete() {
    }

    applyStateConcrete() {

    }
}
